import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import * as AlertGroupActions from '../_actions/alertGroup';
import { AlertGroup } from '../_models';

export interface AlertGroupState extends EntityState<AlertGroup> {
  loading: boolean;
  error: any;
}

export const adapter: EntityAdapter<AlertGroup> = createEntityAdapter<AlertGroup>();

const initialState: AlertGroupState = adapter.getInitialState({
  loading: false,
  error: null,
});

const AlertGroupReducer = createReducer(
  initialState,

  on(AlertGroupActions.loadAlertGroups, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(AlertGroupActions.loadAlertGroupsSuccess, (state, { alertGroups }) =>
    adapter.setAll(alertGroups, { ...state, loading: false })
  ),

  on(AlertGroupActions.loadAlertGroupsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(AlertGroupActions.addAlertGroupSuccess, (state, { alertGroup }) =>
    adapter.addOne(alertGroup, state)
  ),

  on(AlertGroupActions.updateAlertGroupSuccess, (state, { alertGroup }) =>
    adapter.upsertOne(alertGroup, state)
  ),

  on(AlertGroupActions.deleteAlertGroupSuccess, (state, { id }) => adapter.removeOne(id, state)),

  on(
    AlertGroupActions.addAlertGroupFailure,
    AlertGroupActions.updateAlertGroupFailure,
    AlertGroupActions.deleteAlertGroupFailure,
    (state, { error }) => ({
      ...state,
      error,
    })
  )
);

export function reducer(state: AlertGroupState | undefined, action: Action) {
  return AlertGroupReducer(state, action);
}

export const { selectAll, selectEntities, selectTotal } = adapter.getSelectors();
